(function () {
    'use strict';

    angular
        .module('app.shared')
        .factory('ScoreDto', ScoreDtoFactory);

    var holeNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 9.1, 10, 11, 12, 13, 14, 15, 16, 17, 18, 18.1, 18.2];

    ScoreDtoFactory.$inject = ['HoleScoreDto', 'holesPlayed'];
    function ScoreDtoFactory(HoleScoreDto, holesPlayed) {
        function ScoreDto(score) {
            if (!(this instanceof ScoreDto))
                return new ScoreDto(score);
            this._score = score;
            this._score.holeScores = this._normalizeHoleData(this._score.holeScores).map(HoleScoreDto.bind(null, score));
            this._score.holes = this._normalizeHoleData([]);
        }

        Object.defineProperties(ScoreDto.prototype = {}, {
            // Main
            id: accessor('id', true),
            individualId: accessor('individualId', true),
            date: accessor('date'),
            courseId: accessor('courseId'),
            teeId: accessor('teeId'),
            holesPlayed: accessor('holesPlayed'),
            formatPlayed: accessor('formatPlayed'),
            esc: { get: getEsc, set: setEsc },
            holeScores: accessor('holeScores', true),
            holes: accessor('holes', true),

            // Misc
            isHoleByHole: accessor('isHoleByHole'),
            isHoleByHoleRequired: accessor('isHoleByHoleRequired'),
            isTrackingStats: accessor('isTrackingStats'),
            isTournament: accessor('isTournament'),
            isPenalty: accessor('isPenalty'),
            attestor: accessor('attestor'),
            isPlayedAlone: accessor('isPlayedAlone'),

            // Extra
            nationalAssociation: accessor('nationalAssociation'),
            facilityId: accessor('facilityId'),
            facilityName: accessor('facilityName'),

            // Adjustment
            differential: accessor('differential'),
            adjustments: accessor('adjustments'),
            adjustedDifferential: accessor('adjustedDifferential'),
            newAdjustement: accessor('newAdjustment'),

            setTee: { value: setTee },
            _normalizeHoleData: { value: _normalizeHoleData },
            toJSON: { value: toJSON }
        });

        // Accessors
        function accessor(field, readonly) {
            var result = { get: get, enumerable: true };
            if (!readonly)
                result.set = set;
            return result;
            function get() { return this._score[field]; }
            function set(value) { this._score[field] = value; }
        }
        function getEsc() {
            return !this.isHoleByHole ? this._score.esc : this._score.holeScores[21].esc;
        }
        function setEsc(value) {
            if (!this.isHoleByHole)
                this._score.esc = value;
        }

        // Methods
        function setTee(tee) {
            this._score.teeId = tee && tee.id || null;
            this._score.holes = this._normalizeHoleData(tee.holes);
        }
        function _normalizeHoleData(holeData) {
            holeData = holeData && holeData.reduce(setMap, {}) || {};
            return holeNumbers.reduce(setArray, []);

            function setMap(map, data) {
                return (map[data.number] = data) && map || map;
            }

            function setArray(result, number, index) {
                var data = Object.assign(holeData[number] || { number: number }, { index: index });
                return result.push(data) && result;
            }
        }
        function toJSON() {
            var that = this,
                holeScores = this.holeScores.filter(filter);

            return {
                id: this.id,
                individualId: this.individualId,
                date: this.date,
                courseId: this.courseId,
                teeId: this.teeId,
                holesPlayed: this.holesPlayed,
                esc: this.esc,
                holeScores: holeScores,
                isHoleByHole: this.isHoleByHole,
                isHoleByHoleRequired: this.isHoleByHoleRequired,
                isTournament: this.isTournament,
                isPenalty: this.isPenalty,
                attestor: this.attestor,
                isPlayedAlone: this.isPlayedAlone,
                nationalAssociation: this.nationalAssociation,
                facilityId: this.facilityId,
                facilityName: this.facilityName
            };

            function filter(holeScore) {
                return that.isHoleByHole &&
                    (
                        (that.holesPlayed === holesPlayed.EighteenHoles && holeScore.number >= 1 && holeScore.number <= 18 && holeScore.number != 9.1) ||
                        (that.holesPlayed === holesPlayed.FrontNine && holeScore.number >= 1 && holeScore.number <= 9) ||
                        (that.holesPlayed === holesPlayed.BackNine && holeScore.number >= 10 && holeScore.number <= 18)
                    );
            }
        }

        return ScoreDto;
    }
})();
